export const PAGE_MAX_WIDTH = 786;

export const PAGE_PADDING = 20;

export const ADMIN_HEADER_HEIGHT = 80;